const StorageType = {
  Flammable: 'Flammable',
  Aerosol: 'Aerosol',
  Other: 'Other'
};

module.exports = Object.freeze(StorageType);